// extracted by mini-css-extract-plugin
export default {"root":"Vs6Imtm7W4GnnKwUqeHA","time":"FpEnb6s7TmpuApnk5WUA"};